import React from 'react';
import './installButton.css';

const platformInstructions = {
  'ios-safari': {
    title: 'Add JG LocalOps to your Home Screen',
    body: 'Keep tasks, rides, and local offers one tap away.',
    steps: ['Tap Share.', 'Tap Add to Home Screen.', 'Tap Add.'],
    note: 'Open from your Home Screen to finish setup.',
  },
  'ios-non-safari': {
    title: 'Open in Safari to add the app',
    body: 'iPhone and iPad install from Safari.',
    steps: [
      'Open this page in Safari.',
      'Tap Share.',
      'Tap Add to Home Screen.',
    ],
    note: 'Open from your Home Screen to finish setup.',
  },
  'android-firefox': {
    title: 'Add JG LocalOps to your Home Screen',
    body: 'Keep local work and offers easy to reach from this phone.',
    steps: ['Tap Menu.', 'Tap Install or Add to Home Screen.'],
    note: 'Open from your Home Screen to finish setup.',
  },
  'android-chrome': {
    title: 'Add JG LocalOps to your Home Screen',
    body: 'Keep local work and offers easy to reach from this phone.',
    steps: ['Tap the browser menu.', 'Tap Install app or Add to Home screen.'],
    note: 'Open from your Home Screen to finish setup.',
  },
  'android-other': {
    title: 'Add JG LocalOps to your Home Screen',
    body: 'Keep local work and offers easy to reach from this phone.',
    steps: ['Open your browser menu.', 'Tap Install or Add to Home Screen.'],
    note: 'Open from your Home Screen to finish setup.',
  },
  other: {
    title: 'Add JG LocalOps to your Home Screen',
    body: 'Keep local work and offers easy to reach from this phone.',
    steps: ['Use your browser menu to add JG LocalOps to your Home Screen.'],
    note: 'Open from your Home Screen to finish setup.',
  },
};

const getInstructions = (platform) =>
  platformInstructions[platform] || platformInstructions.other;

const PwaInstallHelpSheet = ({
  canNativeInstall,
  nativePromptDismissed,
  onClose,
  onInstall,
  open,
  platform,
}) => {
  if (!open) return null;

  const instructions = getInstructions(platform);
  const showNativeInstall = canNativeInstall && platform === 'android-chrome';
  const showFallback =
    nativePromptDismissed || (!canNativeInstall && platform === 'android-chrome');

  return (
    <div className="pwaInstallSheetBackdrop" role="presentation">
      <div
        aria-labelledby="pwa-install-title"
        aria-modal="true"
        className="pwaInstallSheet"
        role="dialog"
      >
        <button
          aria-label="Close install help"
          className="pwaInstallSheetClose"
          onClick={onClose}
          type="button"
        >
          x
        </button>
        <div className="pwaInstallSheetEyebrow">JG LocalOps</div>
        <h2 id="pwa-install-title">{instructions.title}</h2>
        <p>{instructions.body}</p>
        {showNativeInstall ? (
          <button
            className="pwaInstallPrimary"
            onClick={onInstall}
            type="button"
          >
            Install app
          </button>
        ) : null}
        {showFallback ? (
          <div className="pwaInstallFallback">
            Use your browser menu to add JG LocalOps to your Home Screen.
          </div>
        ) : null}
        <ol className="pwaInstallSteps">
          {instructions.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
        <div className="pwaInstallSheetNote">{instructions.note}</div>
        <button
          className="pwaInstallSecondary"
          onClick={onClose}
          type="button"
        >
          Not now
        </button>
      </div>
    </div>
  );
};

export default PwaInstallHelpSheet;
